import React, { useContext, useEffect, useState, useRef } from 'react'
import { dataContext, localestr, itemToText, toText, uid, beginMn, endMn, load } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import Menu from '../cmp/menu'
import Panel from '../cmp/Panel'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import icon from '../icons.svg'

let loading = false

let findDlg = false

function DocPaymentEdit({ data, actions }) {
  const targetRef = useRef()

  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabNew = actions.tabNew
  const tabClose = actions.tabClose
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  //const getData=context.getData
  //const saveData=context.saveData
  //const addTWnd=context.addTWnd
  const msg = context.msg
  const loaddata = context.loaddata
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings().docPaymentEdit
  const inputCols = context.inputCols
  //const msg_arr=context.msg_arr

  const catEmployees = context.data['catEmployees']
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const isAuthor = (context.user || {}).id===(wndData.author || {}).id
  let posted = parseInt(wndData.posted || 0) && !urAdmin
  let minDate = (new Date()).toISOString()
  if((context.user || {}).rights?.urDocs3Edit){
    let d = new Date()
    d.setDate(d.getDate() - 3)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocs7Edit){
    let d = new Date()
    d.setDate(d.getDate() - 7)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocsREdit){
    if(context.last_rev && context.last_rev < minDate) minDate = context.last_rev
  }
  if(urAdmin){
    let d = new Date()
    d.setDate(d.getDate() - 1095) // 3 роки взад
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if(posted){
    if(wndData.date && wndData.date > minDate){
      if(isAuthor && (context.user || {}).rights?.urDocsOEdit) posted=false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
      if((context.user || {}).rights?.urDocsSEdit) posted=false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
    }
  }

  //const [edit, setEdit] = useState(false)
  const edit = (getGlData() || {}).edit
  const setEdit = (d) => { setGlData({ edit: d }) }
  const [isActive2, setisActive] = useState(false)
  const cols = [
    { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
    { caption: localestr('Працівник'), minWidth: '70', dataId: 'employee', sortable: true, typeVal: 'catEmployees', setFn: (d) => { setVal('employee', d) } },
    { caption: localestr('Сума'), minWidth: '90', maxWidth: '100', dataId: 'sum_amount', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_amount', d) } },
  ]

  if (usersettings && usersettings.cols) {
    for (let i = 0; i < usersettings.cols.length; i++) {
      const idx = cols.findIndex(el => el.dataId === usersettings.cols[i])
      if (idx !== -1) cols[idx].hiden = true
    }
  }

  const filterData = [ //+
    { caption: localestr('Працівник'), dataId: 'employee', typeVal: 'catEmployees' },
    { caption: localestr('Сума'), dataId: 'sum_amount', typeVal: 'number' },
  ]

  const setFilter = (id, val, type) => {
    let filter = [...(wndData.filter || [])]
    const idx = filter.findIndex(el => el.dataId === id)
    if (idx !== -1) {
      if (!val) filter.splice(idx, 1)
      else filter[idx].value = val
    } else if (val) filter.push({ dataId: id, compare: 'lk', value: val, typeVal: type })
    if (!filter.length) filter = undefined
    setWndData({ ...wndData, filter, currentCol: undefined })
    setGlData({ needFocus: 1 })
    tblPos(0)
  }

  const showHideFilter = () => {
    const showAFilter = !wndData.showAFilter
    if (!showAFilter) setWndData({ ...wndData, filter: undefined, showAFilter })
    else setWndData({ ...wndData, showAFilter })
  }

  const listFromData = (currentCol, setCurrCol) => {
    let list = []
    if (wndData.table) list = wndData.table.map((item) => {
      const newItem = {
        uid: uid(),
        id: item.id,
        employee: { id: item.employee_id, name: item.employee, obj_type: 'catEmployees', 'taxes': item.taxes, 'tax_base': item.tax_base, 'expenses': item.expenses },
        sum_amount: item.amount,
      }
      if (item.edit) newItem.edit = true
      if (typeof currentCol !== 'undefined' && currentCol.id === item.id) setCurrCol(newItem)
      return newItem
    })
    return list
  }

  const sortList = (col, sort, list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (typeof list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      if (!col) return 0
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = vala.toLowerCase()
        valb = valb.toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, sorting, currentCol })
  }

  const setHidenCols = (data) => {
    if (data) {
      const new_data = data.filter(el => el.hiden).map(el => el.dataId)
      setSettings({ docPaymentEdit: { cols: new_data } })
    } else {
      if (edit) return
      inputCols(cols, setHidenCols)
    }
  }

  const setCol = (currentCol) => {
    if (!posted) setisActive(true)
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    if ((getGlData() || {}).edit) { saveValue(() => { setCol(currentCol) }); return }
    //const list=wndData.list
    //const sorting=wndData.sorting
    //setWndData({...wndData,currentCol})
    const oldCol = { ...currentCol }
    setWndData({ ...wndData, currentCol, oldCol })

    setGlData({ needFocus: 0 })
  }

  const setVal = (name, data) => {
    if (!wndData.salaryData) { getData(null, () => setVal(name, data)); return }
    let currentCol = { ...wndData.currentCol }
    currentCol[name] = data
    if (name === 'employee') {
      currentCol.expenses = currentCol.employee.expenses
      //Перерахувати все
      currentCol = { ...wndData.currentCol, ...fillEmployee(data) }
    }
    setWndData({ ...wndData, currentCol })
    setEdit(true)
  }

  const cancelEdit = () => {
    if (!isActive()) return
    setEdit(false)
    setisActive(false)
    setGlData({ lastCol: 0, needFocus: 0 })
    const newData = actions.getWndData()
    if (newData.oldCol) {
      newData.currentCol = { ...newData.oldCol }
      newData.oldCol = undefined
      newData.list = newData.list.map(el => el.uid !== newData.currentCol.uid ? el : { ...newData.currentCol })
      setWndData(newData)
    } else {
      const list = newData.list.filter(el => el.uid !== newData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined, oldCol: undefined })
    }
  }

  const filter = (fltr) => {
    let showFilter = !wndData.showFilter
    let filter = wndData.filter
    if (fltr !== undefined) filter = fltr
    if (showFilter || fltr === undefined) setWndData({ ...wndData, showFilter, filter })
    else {
      setWndData({ ...wndData, showFilter, filter, currentCol: undefined })
      setGlData({ needFocus: 1 })
      tblPos(0)
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    setisActive(false)
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (name === 'payType') newData['salaryData'] = null
    if (!newData.edit) newData.edit = true
    setWndData(newData, true)
  }

  const saveValue = (act = null) => {
    if (!isActive()) return
    let errmsg = ''
    const currCol = { ...wndData.currentCol, edit: true }
    const list = wndData.list
    if (!currCol) return
    if (!currCol.employee) errmsg = localestr("Не заповнено працівника")
    if (!currCol.sum_amount) errmsg += localestr("Не заповнено суму")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      currCol.sum_amount = (parseFloat(currCol.sum_amount || 0) || 0).toFixed(2)
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list }
      recountTax(newData)
      setWndData(newData, true)
      setEdit(false)
      setisActive(false)
      if (act === -1) setGlData({ lastCol: 0, needFocus: 0 })
      else if (act) setTimeout(() => { act() }, 100)
    }
  }

  const newItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { newItem() }); return }
    //if (edit) return
    setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setGlData({ lastCol: 0, needFocus: 0 })
    setEdit(true)
  }

  const copyItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { copyItem() }); return }
    //if (edit) return
    if (typeof wndData.currentCol === 'object') {
      setisActive(true)
      let currentCol = { ...wndData.currentCol, uid: uid() }
      delete currentCol.id
      const list = wndData.list.concat(currentCol)
      setWndData({ ...wndData, list, currentCol })
      setGlData({ needFocus: 0, lastCol: 0 })
      setEdit(true)
    }
  }

  const editItem = () => {
    return
    /*if(posted) return
    if (edit) return
    if (!wndData.currentCol) return
    const currentCol={...wndData.currentCol}
    const oldCol={...wndData.currentCol}
    setWndData({...wndData,currentCol,oldCol})
    setEdit(true)*/
  }

  const editClick = () => {
    if (typeof wndData.currentCol === 'object') editItem()
  }

  const selectionProc = (e) => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionProc(e) }); return }
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    let newData = { ...wndData, findText: '', findArr: null }
    let list = newData.list
    let el = list.find(m => m.employee.id === e.id)
    if (!el) {
      el = { ...fillEmployee(e), uid: uid(), edited: true }
      list.push(el)
    } else if (el.hide) {
      el.hide = false
      el.edited = true
    } else {
      el.edited = true
    }
    newData.currentCol = { ...el }
    newData.list = list
    recountTax(newData)
    if (newData.currFind !== undefined) {
      newData.currFind = undefined
      //Тут фокусування на пошуку 'search'
      setTimeout(() => {
        const el = document.getElementById('search')
        if (el) el.focus()
      }, 200)
    }
    setWndData(newData, true)
    setGlData({ needFocus: -2, lastCol: 0 })
  }

  const removeItem = () => {
    if (posted) return
    //if (edit) return
    if ((getGlData() || {}).edit) { saveValue(() => { removeItem() }); return }
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edit: true, hide: true }
    const list = wndData.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData, list, currentCol }
    setWndData(newData, true)
    setGlData({ needFocus: 0 })
  }

  const getData = (d, act) => {
    if (d) {
      const status = d.status
      let loaded = 1
      if (wndData.loaded) {
        loaded += wndData.loaded
      }
      if (loaded > 10) loaded = 0
      if (loaded > 1) return
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      else if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      setWndData({ ...wndData, salaryData: d.data, loaded })
      setTimeout(() => { wndData = actions.getWndData(); act() }, 100)
    } else {
      if (wndData.payType === '0') {
        let from = beginMn(wndData.date).toISOString().substring(0, 19) + 'Z'
        let to_ = endMn(wndData.date)
        to_.setDate(15)
        let to = to_.toISOString().substring(0, 19) + 'Z'
        load('action=getSalaryData&data=' + JSON.stringify({ from, to }), (dt) => { getData(dt, act) })
      } else if (wndData.payType === '1') {
        let to = (new Date(wndData.date)).toISOString().substring(0, 19)
        load('action=getSalaryData2&data=' + JSON.stringify({ to }), (dt) => { getData(dt, act) })

      }
    }
  }

  const fillEmployee = (emp) => {
    const currentCol = { employee: emp }
    const empl = catEmployees.find(el => el.id === emp.id)
    if (empl) {
      currentCol.employee = empl
      currentCol.sum_amount = ''
      if (wndData.payType === '0') {
        let expenses = empl.expenses || ''
        let days = 0
        let hours = 0
        let amount_a = 0
        let amount_d1 = 0
        let amount_d2 = 0
        let amount_t = 0
        let sum_m = parseFloat(empl.sum_m) || 0
        let sum_d = 0
        let sum_h = 0
        let sum_a = 0
        let sum_d1 = 0
        let sum_d2 = 0
        let sum_t = 0
        if (wndData.salaryData) {
          const dates = wndData.salaryData.dates
          let idx = wndData.salaryData.time.findIndex(el => el.employee_id === currentCol.employee.id)
          if (idx !== -1) {
            days = wndData.salaryData.time[idx].days
            hours = Math.round(wndData.salaryData.time[idx].mins / 60)
          }
          if (currentCol.employee.author && currentCol.employee.author.id) {
            amount_a = wndData.salaryData.sales.reduce((a, c) => { return a + (c.author_id === currentCol.employee.author.id ? c.amount : 0) }, 0)
          }
          if (currentCol.employee.department1 && currentCol.employee.department1.id) {
            amount_d1 = wndData.salaryData.sales.reduce((a, c) => { return a + (dates.findIndex(it => it === currentCol.employee.id + '&&' + c.date) !== -1 && c.department_id === currentCol.employee.department1.id ? c.amount : 0) }, 0)
          }
          if (currentCol.employee.department2 && currentCol.employee.department2.id) {
            amount_d2 = wndData.salaryData.sales.reduce((a, c) => { return a + (dates.findIndex(it => it === currentCol.employee.id + '&&' + c.date) !== -1 && c.department_id === currentCol.employee.department2.id ? c.amount : 0) }, 0)
          }
          amount_t = wndData.salaryData.sales.reduce((a, c) => { return a + (dates.findIndex(it => it === currentCol.employee.id + '&&' + c.date) === -1 ? 0 : c.amount) }, 0)
        }
        if (currentCol.employee.sum_d) sum_d = parseFloat(currentCol.employee.sum_d || 0) * parseFloat(days || 0)
        if (currentCol.employee.sum_h) sum_h = parseFloat(currentCol.employee.sum_h || 0) * parseFloat(hours || 0)
        if (currentCol.employee.prc_a) sum_a = parseFloat(currentCol.employee.prc_a || 0) * parseFloat(amount_a || 0) / 100
        if (currentCol.employee.prc_d1) sum_d1 = parseFloat(currentCol.employee.prc_d1 || 0) * parseFloat(amount_d1 || 0) / 100
        if (currentCol.employee.prc_d2) sum_d2 = parseFloat(currentCol.employee.prc_d2 || 0) * parseFloat(amount_d2 || 0) / 100
        if (currentCol.employee.prc_t) sum_t = parseFloat(currentCol.employee.prc_t || 0) * parseFloat(amount_t || 0) / 100
        const totall = sum_m + sum_d + sum_h + sum_a + sum_d1 + sum_d2 + sum_t
        let tax_base = 0
        let taxes = 0
        if (parseInt(currentCol.employee.taxes || 0)) {
          tax_base = totall || 0
          if (parseFloat(currentCol.employee.tax_base || 0) !== 0) tax_base = parseFloat(currentCol.employee.tax_base || 0)
          const mil_tax = parseFloat(currentCol.tax_base || 0) * 0.015
          const inc_tax = tax_base * 0.18
          taxes = inc_tax + mil_tax
        }
        let amount = totall
        if (parseInt(currentCol.employee.taxes || 0) && !parseInt(expenses || 0)) amount -= taxes
        currentCol.sum_amount = amount.toFixed(2)
      } else {
        if (wndData.salaryData.salary) {
          let idx = wndData.salaryData.salary.findIndex(el => el.employee === currentCol.employee.id)
          if (idx !== -1) {
            currentCol.sum_amount = wndData.salaryData.salary[idx].sum
          }
        }
      }
      currentCol.edit = true
    }
    return currentCol
  }

  const recountTax = (dat) => {
    if (dat.payType === '1') return
    if (!dat.list) return
    let inc_tax = 0
    let mil_tax = 0
    let esv = 0
    for (let i = 0; i < dat.list.length; i++) {
      const item = dat.list[i]
      if (parseInt(item.employee.taxes || 0) === 0) continue
      let tax_base = parseFloat(item.sum_amount || 0) / 0.805
      if (parseFloat(item.employee.tax_base || 0) !== 0) tax_base = parseFloat(item.employee.tax_base || 0) / 2
      mil_tax += tax_base * 0.015
      inc_tax = +tax_base * 0.18
      esv = tax_base * 0.22
    }
    dat.inc_tax = inc_tax.toFixed(2)
    dat.mil_tax = mil_tax.toFixed(2)
    dat.esv = esv.toFixed(2)
  }

  const fillDoc = (clr = 1) => {
    if (posted) return
    if (!wndData.salaryData) { getData(null, fillDoc); return }
    if (wndData.list && wndData.list.length && clr) {
      msg(localestr('Документ буде очищено перед заповненням. Продовжити?'), localestr('Запитання'), [{ caption: localestr('Так'), action: () => fillDoc(0) }, { caption: localestr('Відмінити'), action: () => { } }])
      return
    }
    const list = []
    if (catEmployees) {
      let from = beginMn(wndData.date).toISOString().substring(0, 19) + 'Z'
      let to = endMn(wndData.date).toISOString().substring(0, 19) + 'Z'
      for (let i = 0; i < catEmployees.length; i++) {
        const item = catEmployees[i]
        if (parseInt(item.marked)) continue
        if (item.start > to) continue
        if (item.finish && item.finish < from) continue
        list.push({ ...fillEmployee(item), uid: uid(), edited: true })
      }
      let newData = { ...wndData, list, sorting: { sort: undefined } }
      if (wndData.payType === '0') recountTax(newData)
      else if (wndData.salaryData && wndData.salaryData.taxes) {
        let inc_tax = 0
        let mil_tax = 0
        let esv = 0
        for (let i = 0; i < wndData.salaryData.taxes.length; i++) {
          const item = wndData.salaryData.taxes[i]
          if (item.acc === '641') inc_tax += parseFloat(item.sum_c || 0) - parseFloat(item.sum_d || 0)
          if (item.acc === '642') mil_tax += parseFloat(item.sum_c || 0) - parseFloat(item.sum_d || 0)
          if (item.acc === '651') esv += parseFloat(item.sum_c || 0) - parseFloat(item.sum_d || 0)
        }
        newData.inc_tax = inc_tax.toFixed(2)
        newData.mil_tax = mil_tax.toFixed(2)
        newData.esv = esv.toFixed(2)

      }
      setWndData(newData, true)
    }
  }

  const saveDoc = (d, close = true) => {
    if ((getGlData() || {}).edit) { saveValue(() => { saveDoc(d, close) }); return }
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      tabClose(false)
    } else {
      wndData = actions.getWndData()
      let data = {}
      if (wndData.edit) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        data.header = { author: wndData.author, date: wndData.date, account: wndData.account, article: wndData.article, payType: wndData.payType, inc_tax: wndData.inc_tax, mil_tax: wndData.mil_tax, esv: wndData.esv, posted: wndData.posted, note: (wndData.note || '').substring(0, 85) }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.author) data.header.author = { id: 'NULL' }
      }
      let table = wndData.list.filter(el => el.edit)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        if (wndData.marked !== '1' && wndData.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = {uid: el.uid, employee: { id: el.employee.id }, amount: el.sum_amount }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }

      if (posted){
        msg(localestr('Не достатньо прав для редагування цього документа'), localestr('Збереження'), [
                { caption: localestr('Відмінити'), action: () => { } },
                { caption: 'Закрити', action: () => { tabClose(false) } }
        ])
        return
      }

      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modPayment&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }

      //зберегти дані по замовчуванню
      setSettings({ DocPaymentEdit: { account: wndData.account, article: wndData.article } })
      if (Object.keys(data).length && wndData.posted && parseInt(wndData.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modPayment&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && (!wndData.marked || parseInt(wndData.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modPayment&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modPayment&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postPayment&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postPayment&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  const findItem = (val) => {
    const newData = { ...wndData, findText: val }
    findDlg = false
    newData.findArr = null
    if (val.length > 1) {
      const Arr = catEmployees.filter(el => (el.id.indexOf(val) === 0 || (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1 || (el.code && el.code.indexOf(val) === 0)) && !parseInt(el.marked))
      if (Arr.length > 10) Arr.splice(10)
      newData.findArr = Arr
      if (Arr.length) findDlg = true
      else { newData.findArr = null; findDlg = false }
    }
    setWndData(newData)
  }

  const findClick = (el) => {
    const newData = { ...wndData, findText: '', findArr: null }
    findDlg = false
    setWndData(newData)
    selectionProc({ ...el })
  }

  const anyKey = (key) => {
    if (!isActive()) return
    if (key === 'Delete') removeItem()
    else if (key === 'Insert') newItem()
    else if (key === 'F9') copyItem()
    else if (key === 'Escape') cancelEdit()
    else if (key === 'shift_F4') tabClose()
    else if (key === 'F2') showHideFilter()
  }

  const objEntries = () => {
    if (wndData.id) {
      const item = { ...wndData, type: 'docPayment' }
      tabNew('repObjEntries', localestr('Проводки') + ' ' + itemToText(item), { object: item }, true)
    }
  }

  const needFocus = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocus = glData.needFocus
    const lastCol = glData.lastCol
    if (needFocus === -2) return -2
    if (isActive() === false) return -1
    if (needFocus === undefined) return -1
    if (reset === -1) setGlData({ needFocus: -1 })
    if (reset) setGlData({ needFocus: reset })
    if (reset > 0) setGlData({ lastCol: reset })
    if (needFocus === 0 && lastCol) return lastCol
    return needFocus
  }

  useEffect(() => {
    if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list)
    else sortList('name', 'asc', wndData.list)
    // eslint-disable-next-line 
  }, [wndData.table])

  useEffect(() => {
    if (catEmployees === undefined) setTimeout(() => { context.getData('catEmployees') }, 10 + Math.floor(Math.random() * 200))
    // eslint-disable-next-line
  }, [context.data['catEmployees']])

  function setActive(el) {
    if (edit) return
    if (!el) return
    if (document.activeElement.nodeName === 'INPUT') return
    if (document.activeElement.id === 'doc_cont') return
    if (el.contains(document.activeElement)) return
    el.focus()
  }

  const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
  const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
  const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter} /> : ''  //+

  let ttlSum = 0
  wndDataList.forEach(el => {
    if (!el.employee) return
    if (!el.hide) ttlSum += parseFloat(el.sum_amount) || 0
  })
  if (ttlSum !== 0) ttlSum = <div style={{ alignSelf: 'self-end', fontWeight: 'bold', paddingRight: '2px', textAlign: 'right' }}>{localestr('Разом') + ': ' + ttlSum.toFixed(2)}</div>
  else ttlSum = ''
  let ttlSum2 = 0
  if (wndData.inc_tax) ttlSum2 += parseFloat(wndData.inc_tax)
  if (wndData.mil_tax) ttlSum2 += parseFloat(wndData.mil_tax)
  if (wndData.esv) ttlSum2 += parseFloat(wndData.esv)
  if (ttlSum2 !== 0) ttlSum2 = <div style={{ alignSelf: 'self-end', fontWeight: 'bold', paddingRight: '2px', textAlign: 'right' }}>{localestr('Податки') + ': ' + ttlSum2.toFixed(2)}</div>
  else ttlSum2 = ''
  const p_open = ttlSum2 ? true : false

  let findItems = null
  if (findDlg && wndData.findArr) {
    setTimeout(() => findDlg = false, 30000)
    const items = wndData.findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small' }
      return (
        <div key={idx} style={stl} onClick={() => { findClick(el) }}>{el.id + ' - ' + el.name}</div>
      )
    })
    findItems = <div className='no-print' style={{ right: '0px', top: '24px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100' }}>
      {items}
    </div>
  }

  const menuData = [
    { name: localestr('Налаштування таблиці'), icon: '#b953', action: setHidenCols },
    { name: localestr('Фільтр'), icon: '#b955', action: filter },
    { name: localestr('Проводки документа'), icon: '#postBut', action: objEntries },
  ]

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 10px)' }} tabIndex='0' id='doc_cont'
        ref={el => { setActive(el); return targetRef }}>
        <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Виплата з/п') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='85' width2='3' disabled={true} />
            <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='45' />
          </div>
          <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Вид')} disabled={posted} Value={wndData.payType} typeVal={'selPayKinds'} setVal={(d) => { setValue('payType', d) }} width1='30' width2='40' />
            <EditCtrl Capt={localestr('Каса')} disabled={posted} Value={wndData.account} typeVal={'catCashAccs'} setVal={(d) => { setValue('account', d) }} width1='36' width2='50' />
          </div>
          <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Стаття')} disabled={posted} Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='50' width2='20' />
            <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='70' width2='20' />
          </div>
        </div>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
            onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
          ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
            onClick={() => showHideFilter()}
            onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          <div tabIndex='0' onClick={() => { fillDoc() }} onKeyUp={(e) => { if (e.key === 'Enter') fillDoc() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '98px', padding: '0px 2px 0 2px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px', textAlign: 'center' }}>
            {localestr('Заповнити')}
          </div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          <div style={{ position: 'relative', padding: '3px' }}>
            <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }}
              onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
              style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
            {findItems}
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
            <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
          </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
        <Panel caption={'Сплачені податки'} width={580} open={wndData.p_head === undefined ? p_open : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
          <div style={{ margin: '2px 0', display: 'inherit' }}>
            <EditCtrl Capt={localestr('ПДФО')} Value={wndData.inc_tax} typeVal={'number'} setVal={(d) => { setValue('inc_tax', d) }} width1='48' width2='120' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Військовий збір')} Value={wndData.mil_tax} typeVal={'number'} setVal={(d) => { setValue('mil_tax', d) }} width1='118' width2='120' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('ЄСВ')} Value={wndData.esv} typeVal={'number'} setVal={(d) => { setValue('esv', d) }} width1='32' width2='125' />
          </div>
        </Panel>
        <div style={{ display: 'flex' }}>
          <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div>{ttlSum}{ttlSum2}</div>
        </div>
        <div className='no-print'>{showFilter}</div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)', outline: 'none', width: 'calc(100% - 6px)' }} tabIndex='0' id='doc_cont'
      ref={el => { setActive(el); return targetRef }}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Виплата з/п') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='112' width2='42' disabled={true} />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='160' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Вид')} disabled={posted} Value={wndData.payType} typeVal={'selPayKinds'} setVal={(d) => { setValue('payType', d) }} width1='30' width2='194' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Каса')} disabled={posted} Value={wndData.account} typeVal={'catCashAccs'} setVal={(d) => { setValue('account', d) }} width1='36' width2='125' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Стаття')} disabled={posted} Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='46' width2='125' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='72' width2='159' />
      </div>
      <div className='toolBar no-print'>
        <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
          onClick={() => newItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
        <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
          onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
        ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
          onClick={() => removeItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
          onClick={() => showHideFilter()}
          onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
        <div tabIndex='0' className='toolBarSeparator'></div>
        <div tabIndex='0' onClick={() => { fillDoc() }} onKeyUp={(e) => { if (e.key === 'Enter') fillDoc() }}
          style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '98px', padding: '0px 2px 0 2px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px', textAlign: 'center' }}>
          {localestr('Заповнити')}
        </div>
        <div tabIndex='0' className='toolBarSeparator'></div>
        <div style={{ position: 'relative', padding: '3px' }}>
          <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }}
            onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
            style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
          <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
          {findItems}
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
          <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
        </Menu></div>
      </div>
      <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
      <Panel caption={'Сплачені податки'} width={580} open={wndData.p_head === undefined ? p_open : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <EditCtrl Capt={localestr('ПДФО')} Value={wndData.inc_tax} typeVal={'number'} setVal={(d) => { setValue('inc_tax', d) }} width1='48' width2='120' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Військовий збір')} Value={wndData.mil_tax} typeVal={'number'} setVal={(d) => { setValue('mil_tax', d) }} width1='118' width2='120' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('ЄСВ')} Value={wndData.esv} typeVal={'number'} setVal={(d) => { setValue('esv', d) }} width1='32' width2='125' />
        </div>
      </Panel>
      <div style={{ display: 'flex' }}>
        <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div>{ttlSum}{ttlSum2}</div>
      </div>
      <div className='no-print'>{showFilter}</div>
    </div>
  )

}

export default DocPaymentEdit